import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '../../types/dynamic-data';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { BsEnvelope } from 'react-icons/bs';
import { CiMobile3 } from 'react-icons/ci';

export function MemberCard({ member }: { member: TDynamicData }) {
  const contacts = [
    {
      icon: <BsEnvelope size={18} className="text-secondary" />,
      label: member?.fields[3]?.value,
      href: `mailto:${member?.fields[3]?.value}`,
    },
    {
      icon: <BsEnvelope size={18} className="text-secondary" />,
      label: member?.fields[4]?.value,
      href: `mailto:${member?.fields[4]?.value}`,
    },
    {
      icon: <CiMobile3 size={20} className="text-secondary" />,
      label: member?.fields[5]?.value,
      href: `tel:${member?.fields[5]?.value}`,
    },
    {
      icon: <CiMobile3 size={20} className="text-secondary" />,
      label: member?.fields[6]?.value,
      href: `tel:${member?.fields[6]?.value}`,
    },
  ].filter(contact => contact.label && contact.label.trim() !== '');

  return (
    <div
      className={cn(
        'ea-member-zone__member-card',
        'flex flex-col items-start justify-start gap-5 p-5',
      )}
    >
      <Link prefetch={false} href={member.fields[8]?.value} target="_blank">
        <Image
          src={member?.image?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(member?.image, member?.name)}
          width={90}
          height={60}
          className="object-contain p-2"
        />
      </Link>

      <div className="flex w-full flex-col items-start justify-start gap-2">
        <div className="flex w-full flex-col items-start justify-start gap-1">
          <p className="text-sm font-normal text-primary">{member.name}</p>
        </div>

        <span className="text-base font-bold text-primary">{member.fields[0]?.value}</span>
        {contacts.map(contact => (
          <Link
            key={contact.label}
            href={contact.href}
            className="flex items-center justify-start gap-2 text-sm text-secondary"
          >
            {contact.icon}
            {contact.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
